import { useEffect } from 'react';

import type { WidgetWriterProps } from '@/components/forms/components/form/writer/widgets/widget.type';

export const usePropsSynchronization = <
  TRjsfProps extends WidgetWriterProps<any, any, any>,
  TCallback extends (...args: any[]) => void
>(
  props: TRjsfProps,
  rjsfProps: TRjsfProps,
  callback?: TCallback
): void => {
  useEffect(() => {
    if (props.value === rjsfProps.value) return;
    const cb = callback ?? props.onChange;
    cb(props.value);
  }, [rjsfProps, callback]);
};
